import React from "react";
import { Row} from "react-flexbox-grid";
import { MdDone, MdAccessTime } from "react-icons/md";
import moment from 'moment'
import styles from './../styles/components/notificationBell.module.scss'

export const Notification = props => {
    const {event, markAsSeen, displayModal} = props
    const date = moment(event.start).format('MM-DD-YYYY HH:mm a')
  return (
    <>
    <Row align="start" className={styles.__notif}>
        <section className={styles.__notif__icon}>
          <MdAccessTime size="22" />
        </section>
        <section className={styles.__notif__content} onClick={() => {displayModal(true, event)}}>
          <h3>{event.title}</h3>
          <small>{date.toString()}</small>
        </section>
        <section className={styles.__notif__check}>
          <MdDone onClick={() => {markAsSeen(event)}} style={{ color: "#68d2df"}} size="24" />
        </section>
      </Row>
    </>
  );
};

Notification.propTypes = {
};
